module.exports = { "default": require("core-js/library/fn/symbol/has-instance"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/symbol/has-instance.js
// module id = 9
// module chunks = 0